export default {
  email: {
    regex:
      /^([a-zA-Z0-9_\-.+]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,63}(?:\.[a-z]{2})?)$/i
  }
};
